
export const showResultsAction = (results) => {
    return { type: 'SHOW_RESULTS', results }
}


export const clearResultsAction = () => {
    return { type: 'CLEAR_RESULTS' }
}
